import React from 'react';
import { connect } from 'react-redux';
import { MEDIA_TYPE } from '../../../base/media';
import { getLocalParticipant, getParticipantById } from '../../../base/participants';
import { getTrackByMediaTypeAndParticipant, getTracksByMediaType, isLocalTrackMuted, isRemoteTrackMuted } from '../../../base/tracks';
import { StatusIndicators, _connect } from './StatusIndicators';
import { DisplayName } from '../../../display-name';

class RPC_StatusIndicators extends StatusIndicators {
    render() {
        const {
            _localParticipant,
            _participantId
        } = this.props;

        return (
            <>
                { super.render() }
                { _localParticipant &&
                    <span className="displayname" id="">You</span>
                }
                { !_localParticipant &&
                    <DisplayName
                        elementID = { `participant_${_participantId}_name` }
                        participantID = { _participantId } />
                }
            </>
        );
    }
}

function _mapStateToProps(state, ownProps) {
    const { participantID } = ownProps;

    // Only the local participant won't have id for the time when the conference is not yet joined.
    const participant = participantID ? getParticipantById(state, participantID) : getLocalParticipant(state);

    const tracks = state['features/base/tracks'];
    let isScreenSharing = false;

    if (participant?.local) {
        const track = getTracksByMediaType(tracks, MEDIA_TYPE.VIDEO);
        isScreenSharing = track?.videoType === 'desktop';
    } else if (!participant?.isFakeParticipant) { // remote participants excluding shared video
        const track = getTrackByMediaTypeAndParticipant(tracks, MEDIA_TYPE.VIDEO, participantID);
        isScreenSharing = track?.videoType === 'desktop';
    }

    return {
        _showScreenShareIndicator: isScreenSharing,
        _localParticipant: participant?.local,
        _participantId: participantID
    };
}

export default _connect(connect(_mapStateToProps)(RPC_StatusIndicators));